import { useCallback } from 'react';
import { LocalParticipant, Participant } from 'livekit-client';
import {
  CameraDisabledIcon,
  CameraIcon as CamIcon,
} from '@livekit/components-react';
import { Tooltip } from '../../Form';

interface ICameraIcon {
  participant?: Participant;
}

export const CameraIcon = ({ participant }: ICameraIcon) => {
  const toggleParticipantCamera = useCallback(() => {
    if (!participant) return;

    if (participant.isLocal) {
      const local = participant as LocalParticipant;
      local.setCameraEnabled(!local.isCameraEnabled);
    }
  }, [participant]);

  const isDisabled = !participant?.isLocal;
  const tooltipText = participant?.isCameraEnabled
    ? 'Turn off camera'
    : 'Turn on camera';

  return (
    <Tooltip title={tooltipText}>
      <span>
        {participant?.isCameraEnabled ? (
          <CamIcon
            className={`icon-on ${isDisabled ? 'disabled' : ''}`}
            onClick={toggleParticipantCamera}
          />
        ) : (
          <CameraDisabledIcon
            className={`icon-off ${isDisabled ? 'disabled' : ''}`}
            onClick={toggleParticipantCamera}
          />
        )}
      </span>
    </Tooltip>
  );
};
